export const defaultLocation = "US"

export const detectCurrentLocation = async (): Promise<string | null> => {
  try {
    if (typeof window !== "undefined" && window.navigator) {
      // 'en-US' -> 'en'
      const browserLang = window.navigator.language.split("-")[0]
      return browserLang
    }
    return null
  } catch (error) {
    console.error("Error detecting browser language:", error)
    return null
  }
}
